<div class="position-fixed bottom-0 end-0 p-4 z-index-2">
  <div *ngFor="let task of tasks$ | async">
    <ng-container *ngComponentOutlet="task.type | appComponentByTask; inputs: task.params"></ng-container>
  </div>
</div>
